import AccordionTab from "components/util/AccordianTab";
import { Autocomplete, Grid, TextField } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { allSelectedData } from "../../../redux/slices/allSelectedDataSlice";
import { clearValidationError } from "../../../redux/slices/formValidationSlice";
import { useParams } from "react-router-dom";

const PropManager: React.FC<Record<any, any>> = (props) => {

  const dispatch = useAppDispatch();
  const requestorPrM = useAppSelector((state) => state.propertyManagerData);
  const selectedData = useAppSelector((state) => state.allSelectedData);
  const validationErrors = useAppSelector((state) => state.formValidation.errors);
  const {formtype}  = useParams()
  
  const requestorPrMOptions = requestorPrM.PrmData.result?.map((prm) => ({
    role: prm.role,
    company: prm.company,
    emailId: prm.emailId,
    firstName: prm.firstName,
    lastName: prm.lastName,
  }));
  
  const secondaryPrM = useAppSelector((state) => state.propertyManagerData);
  const secondaryPrMOptions = secondaryPrM.SecondaryPrmData.result?.map((prm) => ({
    role: prm.role,
    company: prm.company,
    emailId: prm.emailId,
    firstName: prm.firstName,
    lastName: prm.lastName
  }));

  const handlePrMChange = (event: any, newValue: any) => {
    dispatch(allSelectedData({
      ...selectedData,
      propertyManager: newValue,
      requestorEmailAddress: newValue?.emailId || ""
    }));
    
    // Clear validation error when value is selected
    if (newValue) {
      dispatch(clearValidationError('propertyManager'));
    }
  };

  const handleSecondaryPrMChange = (event: any, newValue: any) => {
    dispatch(allSelectedData({
      ...selectedData,
      secondaryPropertyManager: newValue
    }));
    
    // Clear validation error when value is selected
    if (newValue) {
      dispatch(clearValidationError('secondaryPropertyManager'));
    }
  };

  return (
    <AccordionTab
      title={"Property Manager"} children=
      {
        <div>
          <Grid container spacing={3} >
            <Grid item xs={12} md={4}>
              <Grid>
                <label>Requestor PrM Name</label><span className="mandatory"> *</span>
              </Grid>
              <Grid>
                <Autocomplete
                  id="RequestorPrMName"
                  options={requestorPrMOptions ?? []}
                  getOptionLabel={(option) => (option.firstName?`${option.firstName} ${option.lastName}` : '')}
                  value={selectedData.propertyManager}
                  disabled = {formtype === "view" || formtype === "approval"}
                  renderInput={(params) => (
                    <TextField 
                      {...params}
                      placeholder={!selectedData.propertyManager ? "Select" : ""}
                      
                      error={!!validationErrors.propertyManager}
                    />
                  )}
                  
                  size="small" 
                  fullWidth={true}
                  onChange={handlePrMChange}
                  isOptionEqualToValue={(option: any, value: any) => {
                    return option?.emailId === value?.emailId;
                  }}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} md={4}>
              <Grid>
                <label>Requestor Email Address</label>
              </Grid>
              <Grid>
                <TextField 
                  size="small" 
                  fullWidth={true} 
                  inputProps={{
                    min: 0,
                    maxLength: 256,
                  }} 
                  value={selectedData.propertyManager?.emailId || ""}
                  disabled
                />
              </Grid>
            </Grid>
            <Grid item xs={12} md={4}>
              <Grid>
                <label>PrM Company</label>
              </Grid>
              <Grid>
                <TextField 
                  size="small" 
                  fullWidth={true} 
                  inputProps={{
                    min: 0,
                    maxLength: 256,
                  }} 
                  value={selectedData.propertyManager?.company || ""}
                  disabled
                />
              </Grid>
            </Grid>
            <Grid item xs={12} md={4}>
              <Grid>
                <label>Secondary PrM</label><span className="mandatory"> *</span>
              </Grid>
              <Grid>
                <Autocomplete
                  id="SecondaryPrM"
                  options={secondaryPrMOptions ?? []}
                  getOptionLabel={(option) => (option.firstName?`${option.firstName} ${option.lastName}` : '')}
                  value={selectedData.secondaryPropertyManager}
                  disabled = {formtype === "view" || formtype === "approval"}
                  renderInput={(params) => (
                    <TextField 
                      {...params} 
                      placeholder={!selectedData.secondaryPropertyManager ? "Select" : ""}
                      error={!!validationErrors.secondaryPropertyManager}
                    />
                  )}
                  size="small" 
                  fullWidth={true}
                  onChange={handleSecondaryPrMChange}
                  isOptionEqualToValue={(option: any, value: any) => {
                    return option?.emailId === value?.emailId;
                  }}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} md={4}>
              <Grid>
                <label>Secondary PrM EmailId</label>
              </Grid>
              <Grid>
                <TextField 
                  size="small" 
                  fullWidth={true} 
                  inputProps={{
                    min: 0,
                    maxLength: 256,
                    onPaste: (e) => {
                      const pastedText = e.clipboardData.getData('text');
                      if (pastedText.length > 256) {
                        e.preventDefault();
                      }
                    }
                  }} 
                  value={selectedData.secondaryPropertyManager?.emailId || ""}
                  disabled
                />
              </Grid>
            </Grid>
          </Grid>
        </div>
      } />
  )
}

export default PropManager;
